import React from 'react'
import {Box,Typography} from '@mui/material'
import './footer.css'
const Footer = () => {
  return (
    <Box className='footer'>
        <Typography component='p'>
            Copyright ©2024 All rights reserved | Developed by Shubham Joshi & Dhruvil Jariwala</Typography>
    </Box>
  )
}

export default Footer